export const AccessPaymentReminderPluginDataAccessors = {
  paymentReminder: (getPluginData, info) => {
    return getPluginData()?.reminder || null;
  }
};
export class AccessPaymentReminderFrontendPlugin {
  constructor() {
    this.pluginId = 'payment-reminder';
    this.dataAccessors = {
      ...AccessPaymentReminderPluginDataAccessors
    };
  }
}